export default __webpack_public_path__ + "static/media/videoResourceIcon.562ca391.svg";